import React from "react";
import { Form, Input, Button, Alert } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import "./style.scss";
import { connect } from "react-redux";
import * as actions from "./action";
import logo from "Assets/Images/logo.png";

const Login = ({ logIn, error, loading }) => {
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    logIn(values.username, values.password);
  };

  return (
    <div className="form-page">
      <Form
        form={form}
        onFinish={handleSubmit}
        className="login-form"
        layout="vertical"
      >
        <center style={{ margin: "12px" }}>
          <img src={logo} alt="Logo da empresa" width={250} />
        </center>
        {error && (
          <Alert
            message={error.msg}
            type={error.type}
            showIcon
            style={{ marginBottom: "16px" }}
          />
        )}
        <Form.Item
          name="username"
          rules={[{ required: true, message: "Usuário é obrigatório." }]}
        >
          <Input
            prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder="Usuário"
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: "Senha é obrigatória." }]}
        >
          <Input.Password
            prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder="Senha"
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            size="large"
            loading={loading}
          >
            Entrar
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

const mapStateToProps = (store) => ({
  user: store.login.user,
  error: store.login.error,
  loading: store.login.loading,
});

const mapDispatchToProps = (dispatch) => ({
  logIn: (user, password) => dispatch(actions.logIn(user, password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
